import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-zinc-100 even:bg-zinc-200 hover:bg-zinc-300" }
const _hoisted_2 = { class: "py-4 px-2 pl-4" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(['text-zinc-500 text-sm text-right pl-4'])
}
const _hoisted_5 = { class: "min-w-[15rem] hover:line-clamp-none lg:line-clamp-2" }
const _hoisted_6 = {
  key: 1,
  class: "flex gap-4 items-center"
}

import { Attribute } from '../types/Attribute';
import { Product } from '../types/Product';
import { formatDataType } from '../formatters/valueFormatters';
import CountryFlag from 'vue-country-flag-next';
import AppStatsComment from './AppStatsComment.vue';
import { Value } from '../types/Value';
import { ScaleIcon } from '@heroicons/vue/outline';
import { computed, reactive, ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  props: {
    product: null,
    columns: null,
    cellClass: null,
    rowNumber: null,
    compared: { type: Boolean }
  },
  emits: ["compare"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'compare'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  product: Product;
  columns: Attribute[];
  cellClass: string[];
  rowNumber: number;
  compared?: boolean;
}





function getProductAttribute(product, attribute): Value | undefined {
  return product.valuesByAttributeId[attribute.id];
}

function getAttributeValue(product: Product, attribute: Attribute) {
  let result = {
    format: null,
  };
  
  const value = getProductAttribute(product, attribute)?.value;
  
  result.format = () => {
    if (value) {
      return formatDataType(attribute.dataType, value);
    } else {
      return '';
    }
  };
  
  result.toString = function () {
    return value;
  };
  
  return result;
}

function getCountryName(code) {
  if (!code) {
    return '';
  }
  
  const codeTrimmed = code.trim();
  
  try {
    return new Intl.DisplayNames(['ru'], { type: 'region' }).of(codeTrimmed);
  } catch (e) {
    console.log(e);
  }
  
  return codeTrimmed;
}

const toggleCompare = () => {
  emit('compare');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _createElementVNode("a", {
        href: "#",
        class: _normalizeClass(["inline-flex justify-center items-center w-10 h-10 rounded-lg shadow-sm", {'bg-zinc-700 text-white hover:bg-teal-600': !__props.compared, 'bg-white hover:bg-teal-300 text-teal-600 hover:text-white': __props.compared}]),
        onClick: _withModifiers(toggleCompare, ["prevent"])
      }, [
        _createVNode(_unref(ScaleIcon), { class: "flex-none w-4 h-4" })
      ], 10, _hoisted_3)
    ]),
    _createElementVNode("td", _hoisted_4, _toDisplayString(__props.rowNumber), 1),
    _createElementVNode("td", {
      class: _normalizeClass([...__props.cellClass])
    }, _toDisplayString(__props.product.category.title), 3),
    _createElementVNode("td", {
      class: _normalizeClass([...__props.cellClass])
    }, _toDisplayString(__props.product.brand.title), 3),
    _createElementVNode("td", {
      class: _normalizeClass(["", [...__props.cellClass]])
    }, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.product.title), 1)
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (attribute) => {
      return (_openBlock(), _createElementBlock("td", {
        key: attribute.id,
        class: _normalizeClass([...__props.cellClass])
      }, [
        (attribute.dataType === 'comment' && getAttributeValue(__props.product, attribute).toString())
          ? (_openBlock(), _createBlock(AppStatsComment, {
              key: 0,
              text: getAttributeValue(__props.product, attribute).toString()
            }, null, 8, ["text"]))
          : (attribute.dataType === 'country')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(CountryFlag), {
                  class: "block flex-none !my-0",
                  country: getAttributeValue(__props.product, attribute).toString()
                }, null, 8, ["country"]),
                _createElementVNode("span", null, _toDisplayString(getCountryName(getAttributeValue(__props.product, attribute)
            .toString())), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(getAttributeValue(__props.product, attribute)
            .format()), 1)
              ], 64))
      ], 2))
    }), 128))
  ]))
}
}

})